<template>
  <div v-if="bloqueado" class="alert alert-success text-center fw-semibold rounded-4 py-3">
    Ya has completado y enviado este formulario. Tus respuestas están guardadas.
  </div>

  <form @submit.prevent="handleSubmit" class="pb-5">
    <div class="row g-4">
      <div class="col-md-6" v-for="([key, bloque], bKey) in Object.entries(respuestas)" :key="bKey"> <!-- v-for="(bloque, bKey) in respuestas" :key="bKey" -->
        <div class="shadow-sm rounded-4 border bg-white p-4 h-100">
          <h5 class="fw-semibold text-dark mb-3">{{ bloque.titulo }}</h5>

          <img v-if="[0, 2, 3].includes(bKey)" :src="getImageForCard(bKey)" :alt="`Imagen tarjeta ${bKey + 1}`" class="img-fluid rounded mb-3" width="300" />

          <div
            class="mb-4"
            v-for="(pregunta, index) in bloque.preguntas"
            :key="index"
          >
            <label class="form-label text-body-secondary small mb-2">{{ pregunta.titulo }}</label>
            <textarea
              class="form-control rounded-3 border-secondary"
              v-model="bloque.preguntas[index].respuesta"
              rows="4"
              style="min-height: 120px; resize: vertical;"
              placeholder="Escribe tu respuesta..."
              :disabled="bloqueado"
              required
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-5 mb-4">
      <button class="px-5 py-2 rounded-pill shadow" type="submit" style="background-color: #4b0082; color: white; border-color: #4b0082;" :disabled="bloqueado">
        <i class="bi bi-send me-2"></i>Enviar Respuestas
      </button>
    </div>
  </form>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { guardarRespuestas } from '../services/respuestasService';
import Swal from 'sweetalert2';

const respuestas = ref({});
const bloqueado = ref(false);

// Imágenes por índice de tarjeta
const getImageForCard = (index) => {
  switch (index) {
    case 0:
      return '/img/productos-1.png'; // Reemplaza con la ruta real
    case 2:
      return '/img/productos-2.png';
    case 3:
      return '/img/productos-3.png';
    default:
      return '';
  }
};

onMounted(() => {
  const data = JSON.parse(localStorage.getItem('usuario'));
  if (data) {
    respuestas.value = data.respuestas;
    bloqueado.value = data.respuestasBloqueadas || false;
  }
});

const handleSubmit = async () => {
  const confirm = await Swal.fire({
    title: '¿Estás seguro?',
    text: 'No podrás modificar las respuestas después de enviarlas.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, enviar',
    cancelButtonText: 'Cancelar',
  });

  if (confirm.isConfirmed) {
    try {
      await guardarRespuestas(respuestas.value);
      bloqueado.value = true;

      Swal.fire('¡Éxito!', 'Tus respuestas fueron enviadas.', 'success');

      localStorage.setItem('usuario', JSON.stringify({ ...JSON.parse(localStorage.getItem('usuario')), respuestasBloqueadas: true }));

    } catch (error) {
      Swal.fire('Error', 'No se pudo guardar. Intenta nuevamente.', 'error');
    }
  }
};
</script>